import AbstractChannel from './AbstractChannel'

export default class Way extends AbstractChannel {

  name = 'way'
  title = 'Way'
  titleShort = 'Way'
  color = '#7f7f7f'

  supportedFeatures = ['blackouts']

}
